import { render, staticRenderFns } from "./PaperWalletToDisplay.vue?vue&type=template&id=51b3f7c8&"
import script from "./PaperWalletToDisplay.vue?vue&type=script&lang=js&"
export * from "./PaperWalletToDisplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports